import { ContactFormPayload, ContactFormResponse } from '../types/contact';
import { apiService } from './api';

export async function submitContactForm(data: ContactFormPayload): Promise<ContactFormResponse> {
  try {
    const response = await apiService.post<ContactFormResponse>('/contact', data, { isPublic: true });
    return response;
  } catch (error: any) {
    if (error.response) {
      throw { status: error.response.status, ...error.response.data };
    }
    throw error;
  }
} 